<template>
  <div class="admin col-12">
    <!-- Show Header at the top of files !-->
    <AdminHeader />

    <!-- Show buttons next to the list !-->
    <div class="col-12">
      <div class="row">
        <div class="col-12 mb-1">
          <button
            id="btn_plant_variety_tab"
            @click="_showTab(1)"
            class="btn btn-plt"
            :class="tab === 1 ? 'selected active' : ''"
          >
            Plant Variety
          </button>
          <span>
            <button
              id="btn_topping_tab"
              @click="_showTab(2)"
              class="btn btn-plt"
              :class="tab === 2 ? 'selected active' : ''"
            >
              Topping
            </button>
          </span>
          <span v-if="false"><!-- TODO: Reactivate when complete -->
            <button
              id="btn_pots_tab"
              @click="_showTab(3)"
              class="btn btn-plt"
              :class="tab === 3 ? 'selected active' : ''"
            >
              Pots
            </button>
          </span>
          <span>
            <button
              id="btn_pot_size_tab"
              @click="_showTab(4)"
              class="btn btn-plt"
              :class="tab === 4 ? 'selected active' : ''"
            >
              Pot Sizes
            </button>
          </span>
          <span>
            <button
              id="btn_pot_setup_tab"
              @click="_showTab(5)"
              class="btn btn-plt"
              :class="tab === 5 ? 'selected active' : ''"
            >
              Pot Setup
            </button>
          </span>
          <span>
            <button
              id="btn_pot_internal_btn"
              @click="_showTab(6)"
              class="btn btn-plt"
              :class="tab === 6 ? 'selected active' : ''"
            >
              Pot Internal Watering
            </button>
          </span>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="row">
        <!-- Plant Variety Detail -->
        <ManagePlantVariety v-show="tab == 1" />

        <!-- Topping Detail -->
        <ManageTopping v-show="tab == 2" />

        <!-- Pots Detail -->
        <ManagePots v-show="tab == 3" />

        <!-- Pot Size Detail -->
        <ManagePotSize v-show="tab == 4" />

        <!-- Pot Setup Detail -->
        <ManagePotSetup v-show="tab == 5" />

        <!-- Pot internal Detail -->
        <ManagePotInternal v-show="tab == 6" />
      </div>
    </div>

    <!-- TAB VIEW !-->
    <div class="row"></div>
  </div>
</template>

<script>
import AdminHeader from "@/components/admin/AdminHeader.vue";
import ManagePlantVariety from "@/components/admin/inventory/manage/ManagePlantVariety.vue";
import ManagePots from "@/components/admin/inventory/manage/ManagePots.vue";
import ManageTopping from "@/components/admin/inventory/manage/ManageTopping.vue";
import ManagePotSize from "@/components/admin/inventory/manage/ManagePotSize.vue";
import ManagePotSetup from "@/components/admin/inventory/manage/ManagePotSetup.vue";
import ManagePotInternal from "@/components/admin/inventory/manage/ManagePotInternal.vue";
import { mapActions, mapState } from "vuex";

export default {
  name: "Inventory",
  data: () => ({
    customer: null,
    loading: false,
    tab: 1,
    show_deleted: false,
    site: null,
    site_id: -1,
  }),

  //MOUNTED
  mounted() {
    this.$nextTick(() => {
      this._getPlantBotanys();
      this._getTabs();
     // this.$refs.customer_detail.new_customer();
    });
  },

  // COMPUTED
  computed: {
    // ...mapState("customers", ["customers", "new_customer"]),
    ...mapState("sites", ["new_site"]),
    ...mapState("inventory", ["getPlantBotanys"]), // inventory.js
  },

  // WATCH
  watch: {
    site(new_value) {
      if (new_value != null) {
        this.$set(this, "site_id", new_value.id);
      } else {
        this.$set(this, "site_id", -1);
      }
    },

//    new_customer(new_value) {
//      this.customer = new_value;
//      this.$refs.new_customer_modal.clear();
//    },

    new_site(new_value) {
      this.site = new_value;
    },
  },

  // METHODS
  methods: {
    ...mapActions[("inventory", ["getPlantBotanys"])],

    _show_deleted() {
      this._show_deleted = !this.show_deleted;
    },

    _showTab(index) {
      this.tab = index;
    },

    _getTabs() {
      return this.tabs;
    },

   _getPlantBotanys(){
      
    },

    _export_myob() {},
  },

  // COMPONENTS
  components: {
    AdminHeader,
    ManagePlantVariety,
    ManageTopping,
    ManagePots,
    ManagePotSize,
    ManagePotSetup,
    ManagePotInternal,
  },
};
</script>
